import { mdiCloseCircle, mdiCloseCircleOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import type { IconProps } from '../../../Icons'
import Container from '../Container'

const CloseIcon = memo((props: IconProps) => {
    const { filled, ...other } = props
    return (
        <Icon
            path={filled ? mdiCloseCircle : mdiCloseCircleOutline}
            size={1}
            {...other}
        />
    )
})

interface CloseButtonProps {
    size?: number
    color?: string
    shadow?: boolean
    title?: string
    onClick?: any
}

const CloseButton = memo((props: CloseButtonProps) => {
    const { size, color, shadow, title, onClick } = props
    return (
        <Container shadow={shadow} title={title}>
            <IconButton onClick={onClick}>
                <CloseIcon color={color ?? '#eee'} size={size} />
            </IconButton>
        </Container>
    )
})

export default CloseButton
